import 'hc-sticky';

export default class SidebarInstance {
    constructor(id) {
        this.instance = new hcSticky(id, {
            top: 70,
            stickTo: '#sidebar_body',
            bottomEnd: 10,
        });
    }

    update() {
        this.instance.update({
            top: 70,
            bottomEnd: 20,
        });
    }
}
